/**MOVE FORM SUBMIT BUTTON FOR CONDITIONAL LOGIC BOOKING FORM
 *
 *
 */
document.addEventListener("DOMContentLoaded", (event) => {
  var bookingForm = document.querySelector(".book-appointment-form");

  if (bookingForm){
    moveSubmitBtn();
    setSubmitBtn();
    hideErrorMessages();
  }

});

// Move submit button (THIS IS FOR UNIFORM CSS STYLING)
function moveSubmitBtn() {
  var bookingForm = document.querySelector(".book-appointment-form_wrapper");

  if (bookingForm) {
    var formListUl = bookingForm.querySelector(".gform_fields");

    var submitBtn = bookingForm.querySelector(
      ".gform_footer input[type=submit]"
    );
    // Create new list element
    const submitList = document.createElement("li");

    // Set submit booking btn id
    submitList.setAttribute("id", "booking_submit_btn");

    submitList.appendChild(submitBtn);

    // Append new li element to form list
    formListUl.appendChild(submitList);
  }
}

function moveSubmitBtnEvent() {
  document
    .querySelector(".book-appointment-form")
    .addEventListener("submit", function (e) {
      console.log(e);
      console.log("addddsd");
      var formListUl = document
        .querySelector(".book-appointment-form_wrapper")
        .querySelector(".gform_fields");

      const submitList = document.createElement("li");
      formListUl.appendChild(submitList);
    });
}

// Set submit button class on form type selection
function setSubmitBtn() {
  var bookingType = document.querySelector(".book-appointment-type");

  if (bookingType) {
    let allChoices = bookingType.querySelectorAll("input");

    var submitBtn = document.getElementById("booking_submit_btn");

    allChoices.forEach((choice) => {
      // Set initial class if checked
      if (choice.checked) {
        submitBtn.classList.add(choice.value);
      }

      choice.addEventListener("click", function (e) {
        submitBtn.classList.remove(...submitBtn.classList);
        submitBtn.classList.add(e.target.value);
      });
    });
  }
}

// Hide error messages when a user types back in the input
function hideErrorMessages() {
  var bookingForm = document.querySelector(".book-appointment-form");

  let allInputs = bookingForm.querySelectorAll(".ginput_container ");

  allInputs.forEach((input) => {
    var errorMessage = input.nextSibling;
    input.addEventListener("input", function (e) {
      if (e.target.value !== "") {
        e.target.classList.add("hide");
        errorMessage ? errorMessage.classList.add("hide") : false;
      } else {
        e.target.classList.remove("hide");
        errorMessage ? errorMessage.classList.remove("hide") : false;
      }
    });
  });
}

// Scroll to confirmation message
window.onload = function () {
  var el = document.querySelector(".gform_confirmation_message");

  if (el) {
    el.scrollIntoView(true);
  }
};

// If form confirmation is displayed, remove anchor from URL so that page can be refreshed
document.addEventListener("DOMContentLoaded", function (event) {
  var el = document.querySelector(".gform_confirmation_message");

  if (window.location.hash.includes("#gf") && el !== null) {
    window.location.href.split("#")[0];
    history.replaceState(null, null, " ");
  }
});
